var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn-info",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.downloadItem({url: _vm.url, name: _vm.name})}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }